module.exports = __webpack_public_path__ + "media/images/favorite-select-tab-7e630eb180ba6ea11fa0a2dcd06fab10.svg";